var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sport-categories"},[(_vm.categories.length)?_c('carousel',{attrs:{"paginationEnabled":false,"navigationEnabled":true,"navigation-next-label":"","navigation-prev-label":"","scrollPerPage":false,"perPageCustom":[
            [320, 1.3],
            [400, 1.7],
            [450, 1.8],
            [525, 2.2],
            [600, 2.5],
            [768, 1.8],
            [900, 2.2],
            [1000, 2.5],
            [1150, 3.5],
            [1300, 3.5],
            [1400, 4],
            [1500, 4.5],
            [1600, 5],
            [1800, 6]
        ]}},_vm._l((_vm.categories),function(category,index){return _c('slide',{key:index},[_c('router-link',{class:['category', { 'category--disabled': category.isDisabled }],attrs:{"id":("category-" + index),"to":category.link}},[_c('div',{staticClass:"category__background",style:({ backgroundImage: 'url(' + category.background + ')' })}),_c('span',[_vm._v(_vm._s(category.name))]),(category.background)?_c('loading-spinner'):_vm._e()],1)],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }